import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-issue-mapping-field-selector',
  templateUrl: './issue-mapping-field-selector.component.html',
  styleUrls: ['./issue-mapping-field-selector.component.scss']
})
export class IssueMappingFieldSelectorComponent {
  @Input() sources: any[] = [];
  @Input() selectedValues: any[] = [];

  @Output() valueChange = new EventEmitter<any[]>();

  filterText = '';
  expandedGroups: { [key: string]: boolean } = {};

  toggleGroup(groupKey: string) {
    this.expandedGroups[groupKey] = !this.expandedGroups[groupKey];
  }

  addAllFromGroup(event: MouseEvent, group: any) {
    event.stopPropagation();
    const newItems = group.children.filter(child => !this.isMapped(child));

    if (newItems.length > 0) {
      const updatedSelection = [...this.selectedValues, ...newItems];
      this.valueChange.emit(updatedSelection);
    }
  }

  isMapped(item: any): boolean {
    return this.selectedValues.some(v => v.Key === item.Key);
  }

  addMapping(item: any) {
    if (!item.id || this.isMapped(item)) { return; }
    const newSelection = [...this.selectedValues, item];
    this.valueChange.emit(newSelection);
  }

  removeMapping(item: any) {
    const newSelection = this.selectedValues.filter(v => v.Key !== item.Key);
    this.valueChange.emit(newSelection);
  }

  removeAll() {
    this.valueChange.emit([]);
  }
}
